import { Components, Theme } from '@mui/material';

import { PrimaryColors } from '../constants';

export const MuiRadio: Components<Theme>['MuiRadio'] = {
  styleOverrides: {
    root: {
      '&.MuiRadio-root.Mui-checked': {
        color: PrimaryColors.diamond,
      },
    },
  },
};
